<template>
  <div>
    <div class="container">
      <img v-lazy="require(`../../assets/404.png`)" alt="" />
      <div>抱歉，暂无页面信息</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.container {
  text-align: center;
  color: #333333;
  font-size: 28px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  img {
    width: 640px;
    height: 640px;
  }
}
</style>
